import { Icon, Typography } from '@/components/common';
import { GenericCard } from '@/components/dashboard';
import Icons from '@/const/icons';
import { useCasePhases, useCaseStep } from '@/hooks';
import { PhaseName } from '@/interfaces';
import clsx from 'clsx';
import Link from 'next/link';
import * as React from 'react';

export const CasePhases: React.FC = () => {
	const { casePhasesData } = useCasePhases();

	return (
		<GenericCard className="w-80 p-8 !min-h-fit md:h-auto">
			<Typography type="regular-18" className="text-black mb-6">
				Case Phases
			</Typography>
			<ul className="space-y-6 relative">
				{/* Line */}
				<div className="bg-grey-20 h-full max-h-[90%] w-[1px] left-4 absolute z-0" />
				{/* Phases */}
				{casePhasesData.map((item) => (
					<Link key={item.id} href={item.href} className="flex">
						<li className="flex items-center relative gap-x-3 z-10">
							<CasePhaseStatusIcon name={item.name} />
							<div>
								<Typography type="semibold-14" className="text-opacity-black">
									{item.name}
								</Typography>
							</div>
						</li>
					</Link>
				))}
			</ul>
		</GenericCard>
	);
};

export const CasePhaseStatusIcon = ({
	name,
	size = 'medium',
}: {
	name: PhaseName;
	size?: 'small' | 'medium' | 'large';
}) => {
	const { isPhaseCompleted } = useCaseStep();
	const { isCurrentPhase } = useCasePhases();
	return (
		<span
			className={clsx('flex justify-center items-center rounded-full', {
				'size-5': size === 'small',
				'size-8': size === 'medium',
				'size-12': size === 'large',
				'bg-green-60': isPhaseCompleted(name),
				'bg-primary': isCurrentPhase(name),
				'bg-grey-20': !isPhaseCompleted(name) && !isCurrentPhase(name),
			})}
		>
			<Icon
				src={isPhaseCompleted(name) ? Icons.checkWhite : Icons.infoCircle}
				className="text-white"
				width={size === 'small' ? 12 : size === 'medium' ? 20 : 24}
				height={size === 'small' ? 12 : size === 'medium' ? 20 : 24}
			/>
		</span>
	);
};
